import axios from 'axios'
const actions = {
    updateUser(context, data) {
        return new Promise(resolve => {
            axios.post('api/updateUser', data) .then(response => {
                if(response.data.status === 1) {
                    resolve({data: response.data.data, status: 1})
                } else if(response.data.status === -1) {
                    resolve({data: response.data.data, status: -1})
                }
            })
        })
    }
}

export default actions
